/* eslint-disable import/no-dynamic-require, global-require */
import React, { Component } from "react";
import ReactSVG from "react-svg";
import { string, bool, shape } from "prop-types";
import { withRouter } from "react-router-dom";
import { resizableRoute } from "pages/_components/Resizable";

class Image extends Component {
    static propTypes = {
        src: string.isRequired,
        className: string,
        wrapperClassName: string,
        isMobileNative: bool,
        styles: shape({}),
        location: shape({}),
    };

    static defaultProps = {
        className: "svg-image",
        wrapperClassName: "svg-wrapper",
        isMobileNative: false,
        styles: {},
        location: {},
    };

    render() {
        const { isMobileNative, src, styles, location, className, wrapperClassName } = this.props;

        const path = src.replace("images/", "").replace(/^\//, "");
        let fullPath = require(`styles/images/${path}`);
        fullPath = fullPath.replace(/^\//, "");

        if (!isMobileNative) {
            const pathDepth = location.pathname.split("/").length - 1;
            const pathPrefix = Array(pathDepth).join("../");
            fullPath = pathPrefix + fullPath;
        }

        return <ReactSVG path={fullPath} className={className} wrapperClassName={wrapperClassName} style={styles} />;
    }
}

export default resizableRoute(withRouter(Image));
